import React, { memo } from 'react'
import logo from '../../assets/img/LogotipoLanding.png'

const SplashScreen = () => {
  return (
    <div id="fuse-splash-screen" className='bg-white'>
      <div className="center">
        <div className="logo">
          <img width="128" src={logo} alt="logo" />
        </div>
        <div className="spinner-wrapper">
          <div className="spinner">
            <div className="inner">
              <div className="gap" />
              <div className="left">
                <div className="half-circle" />
              </div>
              <div className="right">
                <div className="half-circle" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default memo(SplashScreen);